import React from 'react';
import { GraduationCap } from 'lucide-react';

const BrandLogo = () => (
  <div className="flex items-center gap-3">
    <div className="h-10 w-10 relative flex items-center justify-center">
       {/* Manejo de error de imagen simple para el logo */}
       <img 
         src="/logo.png" 
         alt="Logo" 
         className="absolute w-full h-full object-contain" 
         onError={(e) => {e.target.style.display='none'; e.target.nextSibling.style.display='flex'}} 
       />
       <div className="hidden w-full h-full bg-indigo-600 rounded-xl shadow-lg items-center justify-center">
          <GraduationCap className="text-white w-5 h-5" />
       </div>
    </div>
    <div className="flex flex-col -space-y-1">
      <span className="text-slate-900 font-black text-xl tracking-tighter">EDUCAT</span>
      <span className="text-[10px] font-extrabold text-indigo-500 tracking-[0.25em]">MEXICO</span>
    </div>
  </div>
);

export default BrandLogo;